import { ProductFilterExpandState } from '../../models/ProductFilterExpandState';

export const toggleExpandedFacet = (previousState: ProductFilterExpandState, facetId: string): ProductFilterExpandState => {
	const { expandedOption: currentExpandedOption, expandedOptionId: currentExpandedOptionId } = previousState;
	if (currentExpandedOption === 'facet' && currentExpandedOptionId === facetId) {
		return { ...previousState, expandedOption: null, expandedOptionId: null };
	}
	return { ...previousState, expandedOption: 'facet', expandedOptionId: facetId };
};
